import MiscellaneousExpensesRepository from '@/shared/http/repositories/business/miscellaneousexpenses'
import TravelExpenseRepository from '@/shared/http/repositories/business/travelexpense'
import Tools from '@/components/tools/Tools'
import { loading } from '@/shared/utils/UIHelper'

const MESES = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ']

// ZC-44: o unico eixo que muda entre os modulos e o repositorio. O texto do status vem MONTADO do
// servidor (em Viagem o 2 e TRANSPORTES, em Diversos e CONTROLADORIA), entao aqui nao ha `if` de
// modulo nenhum — mesma decisao do VisaoGeralDespesas no ZC-43.
const MODULO = {
  diversos: { repositorio: MiscellaneousExpensesRepository },
  viagem: { repositorio: TravelExpenseRepository }
}

export default {
  name: 'LogDespesa',
  props: {
    // Trilha de UMA despesa (aba Log do detalhe). Trocar o id recarrega — e o que faz o componente
    // servir a navegacao entre despesas sem o pai ter de chamar nada.
    despesaId: { type: String, default: null },
    // Trilha CONSOLIDADA (aba Log da Lista de Despesa): os ids que a GRID carregou. Nao e
    // funcionario+empresa de proposito — o endpoint da grid filtra por perfil e pagina, entao
    // refazer o criterio aqui garantiria log divergindo do que a pessoa ve na tela.
    despesaIds: { type: Array, default: null },
    // 'diversos' e o default para nao mexer na tela que ja esta no ar
    modulo: { type: String, default: 'diversos', validator: v => Object.prototype.hasOwnProperty.call(MODULO, v) }
  },
  data () {
    return {
      log: [],
      busca: '',
      carregou: false
    }
  },
  computed: {
    repositorio () {
      return (MODULO[this.modulo] || MODULO.diversos).repositorio
    },
    // mostra a despesa de origem em cada cartao so quando ha mais de uma na trilha; no detalhe de
    // uma despesa so, repetir "06/07 · Passagem · R$ 46,65" em todo cartao e ruido
    mostraOrigem () {
      return Array.isArray(this.despesaIds) && this.despesaIds.length > 1
    },
    // A busca casa contra a frase, a acao, o motivo e o nome de quem assinou — nao so o titulo,
    // como no Log de Viagem, onde procurar pelo nome da pessoa nao acha nada.
    logFiltrado () {
      const termo = (this.busca || '').trim().toUpperCase()
      if (!termo) return this.log
      return this.log.filter(l => [l.titulo, l.acao, l.motivoRecusa, l.nomeConta, l.despesaCategoria]
        .some(c => (c || '').toUpperCase().includes(termo)))
    }
  },
  watch: {
    despesaId: {
      immediate: true,
      handler () { this.recarregar() }
    },
    despesaIds: {
      immediate: true,
      handler () { this.recarregar() }
    },
    modulo () { this.recarregar() }
  },
  methods: {
    recarregar () {
      this.log = []
      this.carregou = false
      if (Array.isArray(this.despesaIds)) {
        if (this.despesaIds.length) this.carregarLista()
        else this.carregou = true
      } else if (this.despesaId) {
        this.carregarUma()
      }
    },
    carregarUma () {
      loading.push()
      this.repositorio.GetLogDespesa(this.despesaId)
        .then(Response => this.receber(Response))
        .catch(Error => this.falhar(Error))
    },
    carregarLista () {
      loading.push()
      this.repositorio.GetLogDespesas(this.despesaIds)
        .then(Response => this.receber(Response))
        .catch(Error => this.falhar(Error))
    },
    receber (Response) {
      // a trilha vem do servidor em ordem crescente (a frase depende da linha anterior);
      // a tela mostra do mais novo para o mais antigo, como o Log de Viagem
      this.log = (Response.data || []).slice().reverse()
      this.carregou = true
      loading.pop()
    },
    falhar (Error) {
      this.log = []
      this.carregou = true
      loading.pop()
      console.log(Error)
    },
    mostrarNomeMes (mes) {
      const n = parseInt(mes, 10)
      return (n >= 1 && n <= 12) ? MESES[n - 1] : ''
    },
    // Tools.formatMoney e o mesmo formatador da coluna Valor da grid: deriva o simbolo da
    // localidade da EMPRESA CORRENTE, e a grid so traz despesa da empresa corrente
    // (`x.EmpresaId == companyId`). Nao inventar 'BRL' fixo aqui — no Chile o valor sai em $.
    formatarValor (v) {
      if (v === null || v === undefined) return ''
      return Tools.formatMoney(v)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/miscellaneousreimbursement/components/LogDespesa/LogDespesa.js